module.exports = __webpack_public_path__ + "static/media/certificationsSection.05af0684.png";